export default "__VITE_ASSET__h32XVAG7__"